import { z } from 'zod';

import { BillingStrategy } from '../../../types';
import { RatingCallRequest } from '../../../value-objects';

const promoCodesValidationBaseSchema = z.object({
  baasAddonIds: z.array(z.string()),
  planGroupId: z.number(),
  planId: z.number(),
  promotionCodes: z.array(z.string()),
});

export const PromoCodesValidationRequestSchema = z.discriminatedUnion('billingStrategy', [
  promoCodesValidationBaseSchema.extend({
    billingStrategy: z.literal(BillingStrategy.Stripe),
    ratingRequest: z.instanceof(RatingCallRequest),
  }),
  promoCodesValidationBaseSchema.extend({
    billingStrategy: z.literal(BillingStrategy.InHouse),
  }),
]);

export type PromoCodesValidationRequest = z.infer<typeof PromoCodesValidationRequestSchema>;
